import css from "styled-jsx/css";

const staticStyles = css`
  @import "src/common/styling/_mixins-scss/screen-size";
  @import "src/common/styling/_mixins-scss/rem";

  .UploadPromoForm {
    display: flex;
    flex-direction: column;

    .UploadPromoForm__banner {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: rem(30px);

      .UploadPromoForm__settings-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: rem(30px);
      }

      .UploadPromoForm__caption {
        font-size: rem(24px);
        font-weight: 300;
      }

      .UploadPromoForm__settings-block {
        display: flex;
        flex-direction: column;
        flex: 3;
        margin-right: rem(30px);
        padding: rem(40px 40px 10px);
      }

      .UploadPromoForm__logo-block {
        display: flex;
        flex-direction: column;
        flex: 2;
        padding: rem(40px 40px 10px);

        :global(.FileField) {
          margin-top: rem(30px);

          :global(.FileField__item-inner) {
            width: rem(200px);
            height: rem(200px);
            margin-right: 0;
          }
        }
      }

      @include respond-to(sm) {
        flex-direction: column;

        .UploadPromoForm__settings-block {
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }

    .UploadPromoForm__buttons {
      display: flex;

      :global(.DefaultButton) {
        &:first-child {
          margin-right: rem(20px);
        }
      }
    }
  }
`;
const getDynamicStyles = ({ colors }) => {
  return css.global`
    .UploadPromoForm__settings-block,
    .UploadPromoForm__logo-block {
      background-color: ${colors.white.hex};
    }

    .UploadPromoForm__description {
      color: ${colors.gray.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
